import {call, put, takeLatest} from "redux-saga/effects";
import {saleWorkingActions} from "./saleWorkingSlice";
import {saleApi} from "~/api";

function* fetchSaleWorkingList(action) {
	try {
		const response = yield call(saleApi.workingGets, action.payload);
		yield put(saleWorkingActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch saleWorking list', error);
		let message = error.message;
		if(error?.response?.data?.message) message = error.response.data.message;
		yield put(saleWorkingActions.fetchDataFailed(message));
	}
}

export default function* saleWorkingSaga() {
	yield takeLatest(saleWorkingActions.fetchData.type, fetchSaleWorkingList);
}